import { FC, useEffect } from "react";
import format from "../../../../utilities/formatNumbers";
import { isNum } from "../../../../utilities/typeGuard";
import calculate from '../../tax/calc/newPriceDecorator'
import { NewPriceCalcTaxDocType } from "../../../../types/taxTypes";

interface TotalNewPriceFieldProps {
  newPriceInput: NewPriceCalcTaxDocType;
  useTechnicalNewPrice: boolean;
  value?: number | null;
  onChange?: (v: number | null) => void;
}

const TotalNewPriceField: FC<TotalNewPriceFieldProps> = ({ newPriceInput, value, onChange, useTechnicalNewPrice }) => {
  useEffect(() => {
    const newPrice = calculate(newPriceInput);
    newPrice !== value && onChange && onChange(newPrice);
  }, [newPriceInput, useTechnicalNewPrice]);

  return <h4 className="mb-0">{format.price(isNum(value) ? value : 0)}</h4>;
};

export default TotalNewPriceField;
